import { getEnumStringValue, ShareOptions_Items_IconMap } from 'js/utils/enum-string-maps';

import Icon from 'components/icon/Icon';

import { IShareOptions } from 'source/NFR.types';

const ShareOptions: React.FC<IShareOptions> = ({ items = [] }) => {
  if (!items.length) return null;

  return (
    <div className="share-options">
      <div className="share-options__options">
        {items.map(link => (
          <div key={link.text} className="share-options__link-container">
            <div className="share-options__link">
              <a href={link.url} target="_blank" rel="noopener noreferrer">
                <Icon name={getEnumStringValue(ShareOptions_Items_IconMap, link.icon) || ''} />
                <span>{link.text}</span>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

ShareOptions.displayName = 'ShareOptions';

export default ShareOptions;
